<div mat-dialog-title class="d-flex justify-content-between align-items-center">
    <h2 class="m-0">{{modalData.data.serviceName}} x {{modalData.data.total_completed_services_qty}}</h2>
    <button mat-icon-button mat-dialog-close>
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <mat-dialog-content>
    <div class="chip_cont" *ngIf="employeeList.length > 0 && checkEmployeeListVisibility()">
        <mat-chip-list aria-label="Fish selection" class="mb-3">
            <div *ngFor="let item of employeeList; let i = index">
                <mat-chip
                (click)="onclickEmployeeName(item,i)"
                style="height: auto"
                *ngIf="item.toShow == true"
                >{{item.name}}
                
              </mat-chip>
            </div>
          
        </mat-chip-list>
      </div>

      <div style="padding-left: 5px;    margin-top: 10px;">
        <!-- <h3 *ngIf="selectedEmployees.length > 0">Job completed</h3> -->
        <div class="" *ngIf="modalData.data.completed_by.length > 0">
          <!-- <mat-chip-list aria-label="Fish selection" class="mb-3">
                <mat-chip
                  style="height: auto"
                  class="selected"
            *ngFor="let item of selectedJobs"
                  >{{item.serviceName}}
                  <mat-icon matChipRemove (click)="removeSelectedJobs(item)" style="color: red;
                  opacity: 1;">cancel</mat-icon>
                </mat-chip>
              </mat-chip-list> -->
          <div *ngFor="let item of modalData.data.completed_by; let i = index;" style="margin-bottom: 35px;    display: flex;
    justify-content: space-between; align-items: center;">
            <div>
                <div
                  
                  style="
                    display: inline-block;
                    width: fit-content;
                    background: #ffc107;
                    padding: 8px 20px;
                    border-radius: 34px;
                    
                  "
                >
                  <p style="margin: 0px; font-weight: 500; font-size: 16px">
                    {{ item.employee_name }}
                  </p>
                </div>
                <mat-icon style="    font-size: 20px;
                font-weight: 900;
                color: #000;
                position: relative;
                top: 4px;
                margin-left: 10px;">close</mat-icon>
                <div style="display: inline-block;">
                  <span style="    margin-left: 10px;
                  border: 1px solid #a2a2a2;
                  padding: 10px;
                  border-radius: 10px;">
                    <button
                    (click)="decreaseEmployeeService(item,i)"
                    style="background: none;
                    border: 1px solid #a2a2a2;
                    border-radius: 25px;
                    width: 25px;
                    height: 25px;">
                    <mat-icon class="material-icons-outlined" style="    font-size: 16px;
                    position: relative;
                    top: 2px;
                    left: -3px;
                    color: #666666;
                    height: auto;
                    width: auto;">remove</mat-icon>
                    </button>
                    <span style="    margin: 0 15px;"> {{item.competed_services_qty}} </span>
                    <button 
                    (click)="increaseEmployeeService(item,i)"
                    style="background: none;
                    border: 1px solid #a2a2a2;
                    border-radius: 25px;
                    width: 25px;
                    height: 25px;">
                    <mat-icon style="    font-size: 16px;
                    position: relative;
                    top: 2px;
                    left: -3px;
                    color: #666666;
                    height: auto;
                    width: auto;" class="material-icons-outlined">add</mat-icon>
                    </button>
                  </span>
                  <!-- <span
                  (click)="removeSelectedJobs(item)"
                  style="text-decoration: underline;
                  margin-left: 20px;
                  display: inline-block;
                  cursor: pointer;">
                    Remove
                  </span> -->
                  
                </div>

            </div>
            <div>
                <mat-icon (click)="removeEmployeeAssignment(item,i)" style="    font-size: 20px;
                font-weight: 900;
                color: red; cursor: pointer;">delete</mat-icon>
            </div>
            <!-- <div >
                by <span style="
              text-decoration: underline;">{{item.completed_by | arrayToStr}}</span>
              </div> -->
          </div>
        </div>

      </div>

  </mat-dialog-content>
  
  <mat-dialog-actions align="end">
    <button
    mat-button
    mat-dialog-close

  >
    Cancel
  </button>
    <button
    (click)="saveAssignment()"
    mat-flat-button
    color="accent"
  >
    Save
  </button>
  </mat-dialog-actions>
  